export function getPeriodFromMinStartTime(state, groupId) {
  const group = state.get('rootReducer').get('groups').get(groupId);
  if (!group || !group.data || !group.data.period) return null;

  return group.data.period.start;
}



// WEBPACK FOOTER //
// ./data/ProgressTestOverview/accessors.js